function asRecord(v: unknown): Record<string, unknown> | null {
  return v && typeof v === "object" ? (v as Record<string, unknown>) : null;
}

function registrationChild(data: Record<string, unknown>): Record<string, unknown> | null {
  const nested = data.registration ?? data.Registration;
  return nested && typeof nested === "object" ? (nested as Record<string, unknown>) : null;
}

function boolField(o: Record<string, unknown> | null, ...keys: string[]): boolean {
  if (!o) return false;
  for (const k of keys) {
    if (o[k] === true) return true;
  }
  return false;
}

/** CRM `Operator_User` — operator-company accounts may switch stakeholder view. */
export function parseRegistrationOperatorUser(registrationProfileData: unknown | null): boolean {
  const root = asRecord(registrationProfileData);
  if (!root) return false;
  const data = asRecord(root.data) ?? root;
  const reg = registrationChild(data);
  return (
    boolField(data, "operatorUser", "OperatorUser") ||
    boolField(reg, "operatorUser", "OperatorUser")
  );
}

/**
 * Stakeholder switcher UI (app-bar label, menu entry) when the user is an operator-company
 * account and more than one stakeholder payload is available for the current context.
 */
export function canUseStakeholderSwitcher(params: {
  registrationProfileData: unknown | null;
  availableStakeholderCodeCount: number;
}): boolean {
  return (
    parseRegistrationOperatorUser(params.registrationProfileData) &&
    params.availableStakeholderCodeCount > 1
  );
}
